<template>
  <b-card :header="caption">
    <b-link :to="{name: 'product-create'}">
      <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
      创建产品
      </b-button>
    </b-link>
    <b-table responsive="sm" :items="items" :fields="fields" :current-page="currentPage" >
    </b-table>
    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="<<" next-text=">>" @change="changePage" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'product',
  mixins: [Error],
  props: {
    caption: {
      type: String,
      default: '产品'
    }
  },
  data: () => {
    return {
      items: [],
      fields: consts.PRODUCT_FIELDS,
      currentPage: 1,
      perPage: consts.DEFAULT_PER_PAGE,
      totalRows: 0
    }
  },
  created () {
    api.fetchListData(this, api.getProductList(), 'products')
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      api.fetchListData(this, api.getProductList(), 'products')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Product.vue?10850724